import Placement from "./Placement";

class Space extends Placement {
  CONGRATULATION = 'нашёл все объекты в игре';
  CONGRATULATION_PLURAL = 'нашли все объекты в игре';
  HEADER = 'Космос'
  CAPTION = 'Найдите объект на карте.'
}

export default Space;
